import React from 'react';
import { Platform, View } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-controller';
import { KEYBOARD_BOTTOM_OFFSET } from '@/components/dashboard-scroll-view';

/** Centraliza o conteúdo e, no celular, deixa rolar quando o teclado sobe. */
const scrollContent = {
  flexGrow: 1,
  justifyContent: 'center' as const,
  alignItems: 'center' as const,
  paddingBottom: 56,
};

/**
 * A coluna do formulário.
 *
 * Na web não rola: o conteúdo cabe na tela e uma barra de rolagem ali só
 * denuncia que não coube. No celular rola, senão o teclado tapa os campos —
 * é o único lugar onde a altura realmente falta.
 */
export function AuthPane({ children }: { children: React.ReactNode }) {
  if (Platform.OS === 'web') {
    return <View className="flex-1 items-center justify-center px-4 pb-14">{children}</View>;
  }

  return (
    <KeyboardAwareScrollView
      bottomOffset={KEYBOARD_BOTTOM_OFFSET}
      className="flex-1"
      contentContainerStyle={scrollContent}
      keyboardShouldPersistTaps="handled"
      showsVerticalScrollIndicator={false}
    >
      {children}
    </KeyboardAwareScrollView>
  );
}
